import { Injectable } from '@angular/core';
import {CesiumAdapterService} from "@src/app/services/cesiumAdapter21/cesium-adapter.service";
import {EsBsModalService} from "@src/app/services/bsModalService/bs-modal.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MetromapService {

  public disabledByLimit = false;
  public usage = 0;
  public _isEnabled: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public imageryIndex = '13';

  public isEventKey = false;

  constructor(protected cesiumAdapterService: CesiumAdapterService, protected modalControl: EsBsModalService) {
    let self = this;

    if (window.hasOwnProperty('METROMAP_IS_EVENT_KEY') && window['METROMAP_IS_EVENT_KEY']) {
      this.isEventKey = window['METROMAP_IS_EVENT_KEY'];
    }

    if (!this.isEventKey) {
      if (window.hasOwnProperty('NEARMAP_USAGE')) {
        this.usage+= window['NEARMAP_USAGE'];
      }

      document.addEventListener('oneTileDownloaded', (e: CustomEvent) => {
        if (e.detail.type == 'metromap') {
          self.usage+= e.detail.size / (1024 * 1024);
          if (self.getUsagePercent() >= 100 && !self.disabledByLimit) {
            self.disabledByLimit = true;
            self.replaceProvider();
            self.modalControl.currentModal = '.nearmap-limit-modal';
            self.modalControl.openModal({backdrop: true, keyboard: false});
          }
        }
      });
    }
  }

  public replaceProvider() {
    this.cesiumAdapterService.viewer.imageryLayers.remove(this.cesiumAdapterService.imageryProviders[this.imageryIndex].layer);
    let defaultKey = this.cesiumAdapterService.getDefaultImageryProviderId();
    this.cesiumAdapterService.imageryProviders[this.imageryIndex].layer = new Cesium.ImageryLayer(
      this.cesiumAdapterService.imageryProviders[defaultKey].provider,
      { show: true }
    );
    this.cesiumAdapterService.viewer.imageryLayers.add(this.cesiumAdapterService.imageryProviders[this.imageryIndex].layer);
  }

  public enable() {
    this._isEnabled.next(true);
    if (!this.isEventKey && this.getUsagePercent() == 100) {
      this.replaceProvider();
      this.modalControl.currentModal = '.nearmap-limit-modal';
      this.modalControl.openModal({backdrop: true, keyboard: false});
    }
  }

  public disable() {
    this._isEnabled.next(false);
  }

  public getLimitMb() {
    if (window.hasOwnProperty('NEARMAP_LIMIT')) {
      return window['NEARMAP_LIMIT'];
    }
    return 0;
  }



  public getUsageMb() {
    return this.usage;
  }

  public getUsagePercent() {
    return Math.min(100, 100 * this.getUsageMb() / this.getLimitMb());
  }
}
